import React, { useState } from 'react';
import { toast } from 'react-toastify';

import { Dropdown, Input } from '../../../components/common/Form';
import ProfileSectionPage from '../../../components/ProfileSectionPage/ProfileSectionPage';
import { STATES } from '../../../constants/StatesConstants';

import './styles/_brand-profile-address.scss';
import BrandProfileActions from './BrandProfileActions';

// TODO (backend ticket): Add brand-level corporate address fields to the database and API.
// Load the saved address from the brand context and persist changes through the brand API.
// This address belongs to the brand itself, not to an individual restaurant location.

const BrandLocationPage = () => {
  const [address1, setAddress1] = useState('');
  const [address2, setAddress2] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [zip, setZip] = useState('');

  const handleSave = () => {
    toast.info('Saving brand addresses will be available once backend support is added.');
  };

  return (
    <ProfileSectionPage title="ADDRESS">
      <form className="location-profile-content" onSubmit={(e) => e.preventDefault()}>
        <div className="brand-profile-address-page">
          <div className="brand-profile-address-inputs">
            <Input
              name="address1"
              label="STREET ADDRESS 1"
              className="brand-profile-address-street1"
              value={address1}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setAddress1(e.target.value)}
            />

            <Input
              name="address2"
              label={
                <span>
                  STREET ADDRESS 2 <i>(Optional)</i>
                </span>
              }
              className="brand-profile-address-street2"
              value={address2}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setAddress2(e.target.value)}
            />
          </div>

          <Input
            name="city"
            label="CITY"
            className="brand-profile-address-city"
            value={city}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCity(e.target.value)}
          />

          <Dropdown
            label="STATE"
            className="brand-profile-address-region"
            onChange={(value: string) => setState(value)}
            value={state}
            values={STATES}
          />

          <Input
            name="zip"
            label="POSTAL"
            className="brand-profile-address-postal"
            value={zip}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setZip(e.target.value)}
          />

          <BrandProfileActions onSave={handleSave} />
        </div>
      </form>
    </ProfileSectionPage>
  );
};

export default BrandLocationPage;
